import React, { FunctionComponent, ReactElement } from 'react';
import { MessageDescriptor } from 'react-intl';

import { MessageType } from '@savgroup-front-common/types';

import { SafeFormattedMessage } from '../../../../formatters';
import Depiction from '../Depiction';
import { InputStatus } from '../helpers/getFinalFieldState.types';

import { $WrapElement, $WrapFix, $Wrapper } from './Wrapper.styles';

interface WrapperProps {
  status?: InputStatus;
  prefix?: string | MessageType | MessageDescriptor;
  suffix?: string | MessageType | MessageDescriptor;
  isHovered?: boolean;
  name?: string;
  isFocused?: boolean;
  isRounded?: boolean;
  dataTestId?: string;
  suffixButton?: ReactElement;
  isFullWidth?: boolean;
  isSmall?: boolean;
  hasIconOnError?: boolean;
}

const Wrapper: FunctionComponent<React.PropsWithChildren<WrapperProps>> = ({
  status = null,
  prefix = '',
  suffix = '',
  isHovered = false,
  isFocused = false,
  isRounded = true,
  dataTestId,
  suffixButton,
  children,
  name,
  isFullWidth = true,
  isSmall = false,
  hasIconOnError,
}) => {
  return (
    <$Wrapper $isFullWidth={isFullWidth}>
      <$WrapElement
        $status={status}
        $isHovered={isHovered}
        $isFocused={isFocused}
        $isRounded={isRounded}
        data-testid={dataTestId}
        $isFullWidth={isFullWidth}
      >
        {prefix && (
          <$WrapFix
            $status={status}
            $isHovered={isHovered}
            $isFocused={isFocused}
          >
            {SafeFormattedMessage(prefix)}
          </$WrapFix>
        )}
        {children}

        {suffix && (
          <$WrapFix
            $status={status}
            $isHovered={isHovered}
            $isFocused={isFocused}
          >
            {SafeFormattedMessage(suffix)}
          </$WrapFix>
        )}
        {hasIconOnError && (
          <Depiction status={status} name={name} isSmall={isSmall} />
        )}
      </$WrapElement>
      {suffixButton && <div>{suffixButton}</div>}
    </$Wrapper>
  );
};

export default Wrapper;
